import { render, staticRenderFns } from "./PatientPicker.vue?vue&type=template&id=ddb62948&scoped=true&"
import script from "./PatientPicker.vue?vue&type=script&lang=js&"
export * from "./PatientPicker.vue?vue&type=script&lang=js&"
import style0 from "./PatientPicker.vue?vue&type=style&index=0&id=ddb62948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb62948",
  null
  
)

export default component.exports